import _ from 'lodash';
import { createSelector } from 'reselect';

export const getCustomerDetails = state => state.customer.profile.details.profileData;

export const getCustomerID = state => state.customer.profile.details.profileData.id;
export const getCustomerPhone = state => state.customer.profile.details.profileData.mobilePhone;
export const getSmsStatus = state => state.customer.profile.details.SMSData.status;

export const smsButtonEnabled = state => state.customer.profile.details.SMSData.buttonEnabled;

export const getDefaultAddress = state => _.find(getCustomerDetails(state).addresses, address => address.addressType === "Default");
export const getOTTStatus = state => state.customer.profile.details.OTTStatus;

export const isLoadingUpdateForm = state => state.customer.profile.details.updateForm.isLoading;
export const isSuccessfulUpdateForm = state => state.customer.profile.details.updateForm.isSuccessful;
export const getUpdateForm = state => state.customer.profile.details.updateForm;

export const getDetailsStatus = state => state.customer.profile.details.profileData.loadingStatus;

export const isLoading = state => getDetailsStatus(state) === 'loading';
export const isFailed = state => getDetailsStatus(state) === 'failed';